








import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  getModule,
} from 'vuex-module-decorators'
import firebase from 'firebase'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import MessageStore from '../../store/modules/messages'
import { rdb } from '../../firebase/init'
import { MessageType, CommentType, NotificationType } from '../../types'

@Component({
  components: {
  },
})
export default class Notification extends Mixins(MainMixin) {
  @Prop() data!:NotificationType

  new:number = 0
}

